module.exports = __webpack_public_path__ + "static/img/mrtx.9fd91d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mrtx.jpg
// module id = ZKHP
// module chunks = 1